/* eslint-disable no-undef */
// @ts-nocheck

import '@src/styles/app.css'
import '@src/styles/colors.css'

import Error500 from './pages/public/errors/500'
import ReactDOM from 'react-dom/client'
import loadable from '@loadable/component'

// These variables are ready to be used
// const isDev = import.meta.env.DEV
// const isProd = import.meta.env.PROD
// const isServer = import.meta.env.SSR
// const envMode = import.meta.env.MODE

const loadEnv = async () => {
  const buildEnv = import.meta.env
  const runtime = window.__RUNTIME_CONFIG__ || {}
  const envProperties = { ...buildEnv, ...runtime }

  console.log('loaded from .env', envProperties)
  window.environment = envProperties
  window.environment.DMF_VERSION = envProperties.DMF_VERSION ?? buildEnv.DMF_VERSION
}
const loadableWithCatch = (loadFun) =>
  loadable(async () => {
    try {
      await loadEnv()
      return await loadFun()
    } catch (err) {
      console.log(err)
      return Error500
    }
  })
const AppBrowser = loadableWithCatch(() => import('@src/AppBrowser'))

document.body.onload = function () {
  // Si la carga es por hot reloading, no hacer nada
  const hotReloading = !!sessionStorage.getItem('hotReloading')
  if (hotReloading) {
    sessionStorage.removeItem('hotReloading')
    return
  }

  // Math.max Evita que haya numeros negativos (si se lanza el beforeunload mas veces de las esperadas)
  const loaded = Math.max(+(localStorage.getItem('dmf-instances') || 0), 0)
  const firstLoaded = !!sessionStorage.getItem('firstLoaded')
  // Si hay una sola pestaña y no es un reload se fuerza un logout para evitar que se abra el navegador con sesion de usuario activa
  if (loaded <= 0 && !firstLoaded) {
    sessionStorage.setItem('logoutOldSession', true)
  }

  // Incrementamos el numero de instancias abiertas
  localStorage.setItem('dmf-instances', loaded + 1)
  // Indicamos que ya se ha hecho la primera carga en la sesion para diferenciar el caso del F5 y evitar que detecte nueva pestaña
  // Session storage es unico por pestaña de navegador
  sessionStorage.setItem('firstLoaded', true)
}

// cierre de sesión al cerrar pestaña o navegador
document.body.onbeforeunload = function () {
  // Si se llama mientras hot reloading, no hacer nada
  const hotReloading = !!sessionStorage.getItem('hotReloading')
  if (hotReloading) {
    return null
  }
  // Se ejecuta al cerrar pestaña o el navegador. Decrementa una instancia por cada pestaña que se cierra
  const loaded = +(localStorage.getItem('dmf-instances') || 0)
  localStorage.setItem('dmf-instances', loaded - 1)
  return null
}

// Detecta evento hot update de vite hmr
// Evita que se generen valores erroneos en dmf-instances ya que no se lanza onbeforeunload pero si onload en ciertas cargas
import.meta.hot &&
  import.meta.hot.on('vite:beforeUpdate', (_) => {
    sessionStorage.setItem('hotReloading', true)
  })

ReactDOM.createRoot(document.getElementById('root')).render(<AppBrowser />)
